import _ from "lodash";
import { Connection, WsClient } from "../WsClient";
import moment from "moment";
import { AbstractService } from "./AbstractService";
import { WebexAccessToken, WebexTokenDTO } from "../types";
import { ConfigurableInterface } from "./ConfigurableInterface";

export interface WmsServiceInterface extends ConfigurableInterface {
  getAccessToken(callback: Function, errorCallback?: Function): void;
  setDeviceUrl(url: string, callback: Function, errorCallback?: Function): void;
}

export class WmsService extends AbstractService implements WmsServiceInterface {
  private isConnected = false;

  private getWsConnection(): Connection {
    const wsClient = WsClient.getInstance();
    const url = `${this.config.wbdServiceUrl}?port=${this.config.wmsServicePort}`;
    return (
      wsClient.getConnection(url) ??
      wsClient.openConnection(url, {
        onReconnect: () => {
          this.isConnected = false;
          this.connect(() => (this.isConnected = true));
        }
      })
    );
  }

  private connect(callback: Function) {
    this.checkConfig([
      "wmsServiceUrl",
      "clientId",
      "clientName",
      "extension",
      "jwt"
    ]);

    /* eslint-disable */
    // @ts-ignore
    const ip = require('ip');
    /* eslint-enable */

    this.getWsConnection().sendRequest({
      method: "/wms_client/connect",
      host: this.config.wmsServiceUrl ?? "",
      jwt: this.config.jwt,
      body: [
        {
          id: this.config.clientId,
          name: this.config.clientName,
          language: 0,
          languages: [],
          status: 2,
          details: "",
          // eslint-disable-next-line @typescript-eslint/camelcase
          ip_addresses: [ip.address()],
          // eslint-disable-next-line @typescript-eslint/camelcase
          device_id: this.config.extension
        }
      ],
      callback,
      errorCallback: () => console.error("Can not connect to WMS")
    });
  }

  private connectIfNotWithCallback(callback: Function) {
    if (this.isConnected) {
      callback();
    } else {
      this.connect(() => {
        this.isConnected = true;
        callback();
      });
    }
  }

  getAccessToken(callback: Function, errorCallback?: Function) {
    this.checkConfig(["wmsServiceUrl", "jwt"]);

    this.connectIfNotWithCallback(() =>
      this.getWsConnection().sendRequest({
        method: "/wms_client/get_token",
        host: this.config.wmsServiceUrl ?? "",
        jwt: this.config.jwt,
        callback: (data: WebexTokenDTO) => {
          callback({
            // eslint-disable-next-line @typescript-eslint/camelcase
            token_string: data.token_string,
            expires: moment()
              .add(data.expiration, "seconds")
              .unix()
          });
          // this.disconnect();
        },
        errorCallback: (err: unknown) => {
          errorCallback?.(err);
          this.disconnect();
        }
      })
    );
  }

  setDeviceUrl(url: string, callback: Function, errorCallback?: Function) {
    this.checkConfig("wmsServiceUrl");

    this.connectIfNotWithCallback(() =>
      this.getWsConnection().sendRequest({
        method: "/wms_client/set_device_info",
        host: this.config.wmsServiceUrl ?? "",
        jwt: this.config.jwt,
        body: {
          // eslint-disable-next-line @typescript-eslint/camelcase
          device_url: url,
          token: "",
          expiration: 0
        },
        callback: (data: unknown) => {
          callback(data);
          this.disconnect();
        },
        errorCallback: (err: unknown) => {
          errorCallback?.(err);
          this.disconnect();
        }
      })
    );
  }

  private disconnect() {
    const wsClient = WsClient.getInstance();
    wsClient.closeConnection(
      `${this.config.wbdServiceUrl}?port=${this.config.wmsServicePort}`
    );
    this.isConnected = false;
  }
}

export class StagingWmsService extends AbstractService
  implements WmsServiceInterface {
  public getAccessToken(callback: Function, errorCallback?: Function) {
    this.checkConfig("stagingRequestDuration");

    setTimeout(() => {
      // eslint-disable-next-line @typescript-eslint/camelcase
      callback({ expires: 100500, token_string: "fake-access-token" });
    }, this.config.stagingRequestDuration);
  }

  public setDeviceUrl(
    url: string,
    callback: Function,
    errorCallback?: Function
  ): void {
    this.checkConfig("stagingRequestDuration");
    setTimeout(() => callback, this.config.stagingRequestDuration);
  }
}
